import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormat } from "hooks/useFormat";
import Typography from "components/basic/typography";
import PolicySection from "./components/PolicySection";
import TableOfContents from "./components/TableOfContents";
import { LAST_UPDATED, policySections } from "./content";

/**
 * Privacy policy. The text lives in content.tsx; this file is layout only.
 *
 * Measure is capped around 70ch because the page is long-form prose — full
 * viewport width would be unreadable on a desktop monitor.
 */
const Privacy: React.FC = () => {
  const { t } = useTranslation("legal");
  const format = useFormat();
  const sections = policySections(t);

  return (
    <Box
      sx={{
        maxWidth: "72ch",
        margin: "0 auto",
        padding: { xs: 2, md: 5 },
        minWidth: 0,
      }}
    >
      <Typography variant="h3" style={{ fontWeight: 700 }}>
        {t("common.privacy_title")}
      </Typography>

      <Typography
        variant="body2"
        sx={{ color: "text.secondary", marginBottom: 4 }}
      >
        {t("common.last_updated", {
          date: format.date(`${LAST_UPDATED}T00:00:00`, {
            day: "numeric",
            month: "long",
            year: "numeric",
          }),
        })}
      </Typography>

      <Typography variant="body1" sx={{ marginBottom: 4 }}>
        {t("common.privacy_intro")}
      </Typography>

      <TableOfContents sections={sections} />

      {sections.map((section) => (
        <PolicySection key={section.id} section={section} />
      ))}
    </Box>
  );
};

export default Privacy;
